import Env from '@/env';
/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function auth({next, router, to, store}) {
  const token = store.getters['auth/token'];
  const authUser = store.getters['auth/user'];
  if (token) {
    if(authUser.role == 'superadmin'){
      return router.push({ name: 'SuperadminDashboard' });
    } else if (authUser.role == 'reseller'){
      return router.push({ name: 'ResellerDashboard' });
    } else {
      return router.push({ name: 'CustomerDashboard' });
    }
  }
  return next();
}